/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const InteractiveEmailService = {
  async getInteractiveEmailModal(screenName, reportName, transactionCode, referenceNo) {
    const requestScreenData = {
      url: `/InteractiveEmailModal?screenName=${screenName}&reportName=${reportName}&transactionCode=${transactionCode}&referenceNo=${referenceNo}`
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async SaveInteractiveEmailModal(payload) {
    var url = "api/Save_InteractiveEmailModal";

    return await ApiService.post(url, payload, "String");
  }
};



export { InteractiveEmailService };
